exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content[data-v-3ff2ba32]{padding:30px}.chart-canvas[data-v-3ff2ba32]{height:400px;width:100%;margin-top:30px}.chart-wrap[data-v-3ff2ba32]{position:relative}.pv-total[data-v-3ff2ba32]{position:absolute;left:120px;top:4px;font-size:14px}", ""]);

// exports
